/**
 * The flag fallback face declared in styles/flagFont.css, which Windows needs
 * because its system emoji font has no country flags. The face carries a
 * `unicode-range` covering flag code points only, so prepending it to a stack
 * changes nothing but flag emoji — all other text still comes from the
 * tenant's font.
 */
export const FLAG_FONT_FAMILY = `'Twemoji Country Flags'`

/** Prepend the flag face to a font stack. */
export function withFlagFont(stack?: string | null): string {
	const family = String(stack ?? '').trim()
	return family
		? `${FLAG_FONT_FAMILY}, ${family}`
		: `${FLAG_FONT_FAMILY}, sans-serif`
}
